export enum UserCredentialType {
  PASSWORD = 1,
  PIN = 2,
}

export const ACTION_TYPES = {
  PIN: 'alterPin',
  PASSWORD: 'alterPassword',
};
